import { useMemo } from 'react';
import { COMMUNICATOR_TRANSCRIPTION } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { COMMUNICATOR_TRANSCRIPTION_PERMISSION } from '../constants/permissions';

const useHasAccessToCommunicatorTranscription = () => {
  const hasCommunicatorTranscriptionCapabilities = useHasCapability(
    COMMUNICATOR_TRANSCRIPTION,
  );
  const hasCommunicatorTranscriptionPermission = useHasPermission(
    COMMUNICATOR_TRANSCRIPTION_PERMISSION,
  );
  const hasAccessToCommunicatorTranscriptionFeature = useMemo(() => {
    return (
      !!hasCommunicatorTranscriptionCapabilities?.hasCapability &&
      !!hasCommunicatorTranscriptionPermission?.hasPermission
    );
  }, [
    hasCommunicatorTranscriptionCapabilities,
    hasCommunicatorTranscriptionPermission,
  ]);
  return hasAccessToCommunicatorTranscriptionFeature;
};

export default useHasAccessToCommunicatorTranscription;
